// 配电柜详情
import React, { PureComponent } from "react";
import { Spin } from "antd";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import fetchHandler from "../../../fetch/fetchHandler";
import { getPowerBoxDetail } from "../../../fetch/fetchApi";

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class PowerBoxDetail extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      result: {},
      stubGroupName: "",
      internationalization: this.props.intl.messages.PowerBoxDetail,
    };
    this.query = {};
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
  }

  componentWillMount() {
    this.query.meterModuleId = this.props.powerboxInfoData.meterModuleId;
    this.setState({
      stubGroupName: this.props.powerboxInfoData.stubGroupName,
    });
    this.getPowerBoxDetail(this.props.powerboxInfoData.meterModuleId);
  }

  // 获取配电柜详情
  getPowerBoxDetail(meterModuleId) {
    this.setState({
      stubSpinning: true,
    });

    fetchHandler(getPowerBoxDetail, {
      meterModuleId: meterModuleId,
    }).then((data) => {
      if (data) {
        this.setState({
          result: data.data,
        });
      }
      this.setState({
        stubSpinning: false,
      });
    });
  }

  showMessage = (value) => {
    return value || value === 0 ? value : "--";
  };

  render() {
    return (
      <Spin spinning={this.state.stubSpinning}>
        <div className="sc-modal-scroll">
          <div className="page-panel">
            <div className="page-info-item">
              <h3>
                <span>{this.state.internationalization.title1}：</span>
              </h3>
              <ul>
                <li className="stationName">
                  <strong>{this.state.internationalization.title2}：</strong>
                  <span>{this.showMessage(this.state.result.meterModuleId)}</span>
                </li>
                <li className="stationName">
                  <strong>{this.state.internationalization.title3}：</strong>
                  <span>{this.showMessage(this.state.stubGroupName)}</span>
                </li>
              </ul>
            </div>
            <div className="page-info-item">
              <h3>
                <span>{this.state.internationalization.title4}</span>
              </h3>
              <ul>
                <li className="stationName">
                  <strong>{this.state.internationalization.wz1}：</strong>
                  <span>
                    {this.state.result.frameWork && this.state.result.updateType
                      ? `${this.state.result.updateType}-${this.state.result.frameWork}`
                      : "--"}
                  </span>
                </li>
                {/* <li className={'stationName'}>
                                    <strong>当前版本号：</strong>
                                    <span>{this.state.result.frameWork}</span>
                                </li> */}
              </ul>
            </div>
            <div className="page-info-item">
              <h3>
                <span>{this.state.internationalization.title7}</span>
              </h3>
              <ul>
                <li className="stationName">
                  <strong>{this.state.internationalization.value1}：</strong>
                  <span>{this.showMessage(this.state.result.currentA)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value2}：</strong>
                  <span>{this.showMessage(this.state.result.voltageA)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value3}：</strong>
                  <span>{this.showMessage(this.state.result.currentB)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value4}：</strong>
                  <span>{this.showMessage(this.state.result.voltageB)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value5}：</strong>
                  <span>{this.showMessage(this.state.result.currentC)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value6}：</strong>
                  <span>{this.showMessage(this.state.result.voltageC)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value7}：</strong>
                  <span>{this.showMessage(this.state.result.electricA)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value8}：</strong>
                  <span>{this.showMessage(this.state.result.electricB)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value9}：</strong>
                  <span>{this.showMessage(this.state.result.electricC)}</span>
                </li>

                <li>
                  <strong>{this.state.internationalization.value10}：</strong>
                  <span>{this.showMessage(this.state.result.powerA)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value11}：</strong>
                  <span>{this.showMessage(this.state.result.powerB)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value12}：</strong>
                  <span>{this.showMessage(this.state.result.powerC)}</span>
                </li>

                <li>
                  <strong>{this.state.internationalization.value13}：</strong>
                  <span>{this.showMessage(this.state.result.electricTotal)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value14}：</strong>
                  <span>{this.showMessage(this.state.result.electricTotalF)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value15}：</strong>
                  <span>{this.showMessage(this.state.result.electricTotalJ)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value16}：</strong>
                  <span>{this.showMessage(this.state.result.electricTotalG)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value17}：</strong>
                  <span>{this.showMessage(this.state.result.electricTotalP)}</span>
                </li>
                <li>
                  <strong>{this.state.internationalization.value18}：</strong>
                  <span>{this.showMessage(this.state.result.powerTotal)}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Spin>
    );
  }
}

export default injectIntl(PowerBoxDetail);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/powerBox/PowerBoxDetail.js